import { motion } from "framer-motion";
import { LOGO_URL, CLUB, CONTACTS } from "@/data";

export default function Contatti() {
    return (
        <div>
            <div className="grid sm:grid-cols-2 gap-5" data-testid="contacts-grid">
                {CONTACTS.map((c, i) => (
                    <motion.a
                        key={c.id}
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        className="parchment-card p-6 flex items-center gap-4"
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: i * 0.07 }}
                        data-testid={`contact-${c.id}`}
                    >
                        <span className="shrink-0 w-12 h-12 rounded-full border border-[#b08d57]/60 bg-[rgba(176,141,87,0.14)] flex items-center justify-center text-[#7a5a2e]">
                            <c.icon size={22} strokeWidth={1.5} />
                        </span>
                        <span>
                            <span className="block f-title text-[0.68rem] tracking-[0.22em] uppercase text-[#9c4a2e]">{c.label}</span>
                            <span className="block f-body italic text-[#43301c] mt-1 text-base sm:text-lg">{c.value}</span>
                        </span>
                    </motion.a>
                ))}
            </div>

            <motion.div
                className="mt-12 flex flex-col items-center text-center gap-5"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6 }}
            >
                <img
                    src={LOGO_URL}
                    alt={`Logo ${CLUB.name}`}
                    draggable={false}
                    className="w-[min(170px,40vw)] select-none"
                    style={{
                        mixBlendMode: "multiply",
                        maskImage: "radial-gradient(circle at 50% 50%, black 55%, transparent 78%)",
                        WebkitMaskImage: "radial-gradient(circle at 50% 50%, black 55%, transparent 78%)",
                    }}
                    data-testid="contatti-logo"
                />
                <p className="f-body italic text-[#6d5638] max-w-md text-base">
                    Per proposte, domande o semplicemente per fare due chiacchiere sui libri: scrivici, il tè è già sul fuoco.
                </p>
            </motion.div>
        </div>
    );
}
